<template>
<iframe
class="pdf-viewer"
:src="viewerUrl"
frameborder="0"
></iframe>
</template>


<script setup>
import { ref } from 'vue'
const viewerUrl = ref(`/pdfjs/web/viewer.html?file=/indroduction.pdf#disableDownload=true`)
</script>


<style scoped>
.pdf-viewer {
width: 100%;
height: 100vh;
border: none;
}
</style>